function TickerTape({ items }) {
  const repeated = [...items, ...items];

  return (
    <div className="ticker-tape" aria-label="Protocol stats">
      <div className="ticker-tape__fade ticker-tape__fade--left" />
      <div className="ticker-tape__fade ticker-tape__fade--right" />
      <div className="marquee-track">
        {repeated.map((item, i) => (
          <span key={i} className="ticker-tape__item">
            {item.label && (
              <span className="ticker-tape__label">{item.label}</span>
            )}
            <span className={`ticker-tape__value ${item.accent ? 'ticker-tape__value--accent' : ''}`}>
              {item.value}
            </span>
            <span className="ticker-tape__sep">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}

export default TickerTape;
